export default "__VITE_ASSET__HgMwFn1q__"